import React from "react";
import ShortcutGroupDialogSkeleton from "./shortcutGroupDialogSkeleton";

interface ICreateShortcutGroupDialogProps {
    show: boolean;
    onClose: () => void;
    onCreateShortcutGroupFromInput: (shortcutGroupName: string) => void;
}

const CreateShortcutGroupDialog: React.FC<ICreateShortcutGroupDialogProps> = ({
    show,
    onClose,
    onCreateShortcutGroupFromInput
}) => {
    return <ShortcutGroupDialogSkeleton 
        show={show}
        onClose={onClose}
        onDialogActionButtonClick={onCreateShortcutGroupFromInput}
        dialogTitle="Create New Shortcut Group"
        dialogActionButtonLabel="Create"
        dialogFieldLabel="Shortcut group name"
    />;
};

export default CreateShortcutGroupDialog;
